export default __webpack_public_path__ + "static/media/nourprofile.52b728c6.jpg";